<a mat-button routerLink="/">
  <img src="assets/images/logo.svg" alt="logo" />
</a>
